
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    VisitTypeModal
} from './visittypesmodal';

export const visittypesathenastate = (
    context: any,
    initial?:VisitTypeModal[],
) => {
    const initValue = initial || [];

    return (
        state: VisitTypeModal[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};
